import React, { useState, useEffect, useContext } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
// components
import Sidebar from '../../components/Sidebar';
import LogoutModal from '../../components/Modals/LogoutModal';
import DeleteAccountModal from '../../components/Modals/DeleteAccountModal';
// API
import Api from '../../API';
// user context
import { UserContext } from '../../userContext';
// helper
import { clearStorage, getUser } from '../../utils/helpers';

const Home = () => {
  const [logoutModalShow, setLogoutModalShow] = useState(false);
  const [deleteModalShow, setDeleteModalShow] = useState(false);

  const [_user, setUser] = useContext(UserContext);

  // update user context from local storage
  useEffect(() => {
    const userFromLocalStorage = getUser();
    if (userFromLocalStorage) {
      setUser(userFromLocalStorage);
    }
  }, [setUser]);

  const navigate = useNavigate();

  const logout = () => {
    clearStorage();
    setUser(null);
    navigate('/', { replace: true });
  };

  const deleteAccount = async () => {
    const response = await Api.deleteAccount();
    if (response.success) {
      logout();
    }
  };

  return (
    <>
      <Sidebar
        logout={logout}
        setLogoutModalShow={setLogoutModalShow}
        setDeleteModalShow={setDeleteModalShow}
      />
      <LogoutModal
        show={logoutModalShow}
        onHide={() => setLogoutModalShow(false)}
        logout={logout}
      />
      <DeleteAccountModal
        show={deleteModalShow}
        onHide={() => setDeleteModalShow(false)}
        deleteAccount={deleteAccount}
      />
      <Outlet />
    </>
  );
};

export default Home;
